module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-新闻资讯banner.12fd3458.png";